/* eslint-disable array-callback-return */
import { Component } from "react";
import { JJ_Icon_Chevron_right, JJ_Icon_Chevron_down,
  magnifyingGlass,
  crossIcon } from "../../assets";
import ApiServices from "../../utils/apiServices";
import trackingService from "../../services/trackingService";
import "../ContentShortcuts/ContentShortcuts.css";
import { CSEPSelectedProduct, CSEPDocumentType } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
// const convertToHtml = (data) => {
//   return <div dangerouslySetInnerHTML={{ __html: data }}></div>;
// };

class EstablishedProductGenAIRec extends Component {
    constructor(props) {
        super(props);
        this.service = new ApiServices();
        this.state = {
            showCSModal: false,
            showInfo: false,
            products: props.products,
            arrayOfDocTypes: [],
            selectedDosageType: [],
            selectedProduct: props.selectedProduct,
            startIndex: 0,
            isSelectedProduct: false,
            showContentDosage: false,
            showContentDocumentType: false,
            dosageType: [],
            selectedDefault: "",
            selectedDosage: "",
            showDocsType: false,
            showNote: true,
            documentTypeSelectStatus: [],
            productSelectStatus: [],
            searchKeyword: "",
            keyBoardEvent: false,
            keyEventName: "",
            selectAll: false,
            selectAllDoc: false,
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
        };
    }

    async componentDidMount() {
       let productSelectStatus = [];
       let documentTypeSelectStatus = [];
       for (let index = 0; index < CSEPSelectedProduct.length; index++) {
           productSelectStatus.push(false);
       }
      for (let index = 0; index < CSEPDocumentType.length; index++) {
           documentTypeSelectStatus.push(false);
      }
      this.setState({
          productSelectStatus: productSelectStatus,
          documentTypeSelectStatus: documentTypeSelectStatus,
    });
    }

    componentDidUpdate = () => {
        if (this.props.showEPCSModal !== this.state.showCSModal) {
            this.setState({ showCSModal: this.props.showEPCSModal });
        }
    };
    handleChangeInSearch = (event) => {
        this.setState({
            searchKeyword: event.target.value,
        });
    };
    handleCancelSearchKeyword = (event) => {
      event.stopPropagation();
        this.setState({
            searchKeyword: "",
        });
    };
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false
        })
    }
    handleOnClickSearchIcon = () => {
        // const newUrl = this.buildUrl(
        //     this.state.searchKeyword,
        //     'Drugs - JNJ/Established Products'
        //     // this.props.appliedFilters
        // );
        // this.props.handleChangeInSearch(this.state.searchKeyword);
        let newUrl;
        let selectedFilters;
        let selectedProducts = this.getSelectedProducts();
        let selectedDocTypes = this.getSelectedDocTypes();
        let csProductVal = selectedProducts.map((data) => data).join(";");
        let csPathVal = selectedDocTypes.map((data) => data).join(";");
        if (
            this.state.searchKeyword.length <= 0 &&
            selectedProducts.length <= 0 &&
            selectedDocTypes.length <= 0
        ) {
            this.errorAlertMessage(
                "Please enter a keyword to search for or select atleast one filter from Product/Document Type!"
            );
        } else {
            if (
                this.state.searchKeyword.length > 0 &&
                selectedProducts.length <= 0 &&
                selectedDocTypes.length <= 0
            ) {
                newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=Drugs - JNJ/Established Products`;
            } else if (
                selectedProducts.length > 0 &&
                this.state.searchKeyword.length > 0 &&
                selectedDocTypes.length <= 0
            ) {
                if (this.state.selectAll) {
                    selectedFilters = "Drugs - JNJ/Established Products";
                } else {
                    selectedFilters = selectedProducts
                        .map((data) => `Drugs - JNJ/Established Products/${data}`)
                        .join(";");
                }
                newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=${selectedFilters}`;
            } else if (
                selectedProducts.length > 0 &&
                this.state.searchKeyword.length <= 0 &&
                selectedDocTypes.length <= 0
            ) {
                if (this.state.selectAll) {
                    selectedFilters = "Drugs - JNJ/Established Products";
                } else {
                    selectedFilters = selectedProducts
                        .map((data) => `Drugs - JNJ/Established Products/${data}`)
                        .join(";");
                }
                newUrl = `/results?query=&q=All Fields&filters=${selectedFilters}`;
            } else if (
                selectedProducts.length <= 0 &&
                this.state.searchKeyword.length <= 0 &&
                selectedDocTypes.length > 0
            ) {
                selectedFilters = selectedDocTypes
                    .map((data) => `Document Type/${data}`)
                    .join(";");
                newUrl = `/results?query=&q=All Fields&filters=Drugs - JNJ/Established Products;${selectedFilters}`;
            } else if (
                selectedProducts.length <= 0 &&
                this.state.searchKeyword.length > 0 &&
                selectedDocTypes.length > 0
            ) {
                selectedFilters = selectedDocTypes
                    .map((data) => `Document Type/${data}`)
                    .join(";");
                newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=Drugs - JNJ/Established Products;${selectedFilters}`;
            } else if (
                selectedProducts.length > 0 &&
                this.state.searchKeyword.length <= 0 &&
                selectedDocTypes.length > 0
            ) {
                let productFilter;
                let docTypeFilter;
                if (this.state.selectAll) {
                    productFilter = "Drugs - JNJ/Established Products";
                } else {
                    productFilter = selectedProducts
                        .map((data) => `Drugs - JNJ/Established Products/${data}`)
                        .join(";");
                }
                docTypeFilter = selectedDocTypes
                    .map((data) => `Document Type/${data}`)
                    .join(";");
                selectedFilters = productFilter.concat(";", docTypeFilter);
                newUrl = `/results?query=&q=All Fields&filters=${selectedFilters}`;
            } else {
                let productFilter;
                let docTypeFilter;
                if (this.state.selectAll) {
                    productFilter = "Drugs - JNJ/Established Products";
                } else {
                    productFilter = selectedProducts
                        .map((data) => `Drugs - JNJ/Established Products/${data}`)
                        .join(";");
                }
                docTypeFilter = selectedDocTypes
                    .map((data) => `Document Type/${data}`)
                    .join(";");
                selectedFilters = productFilter.concat(";", docTypeFilter);
                newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=${selectedFilters}`;
            }
            //this.props.history.push(newUrl);
            window.open(newUrl, "_blank");
            const ts = new trackingService();
            ts.indexTrackingData(
                localStorage.getItem("userdisplayName"),
                localStorage.getItem("wwid"),
                localStorage.getItem("username"),
                localStorage.getItem("function"),
                localStorage.getItem("region"),
                localStorage.getItem("userproducts"),
                localStorage.getItem("doctypepref"),
                localStorage.getItem("sid"),
                localStorage.getItem("deviceType"),
                localStorage.getItem("deviceOS"),
                localStorage.getItem("browserName"),
                localStorage.getItem("browserVersion"),
                localStorage.getItem("jnjDepartment"),
                localStorage.getItem("companyname"),
                "Conducted Established Products Search",
                "",
                window.location.href,
                this.state.searchKeyword,
                selectedProducts.length <= 0 &&
                    this.state.searchKeyword.length <= 0 &&
                    selectedDocTypes.length > 0
                    ? `Drugs - JNJ/Established Products;${selectedFilters}`
                    : selectedFilters
                        ? selectedFilters
                        : "Drugs - JNJ/Established Products", //this.props.appliedFilters,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                `Established Products - ${csPathVal}`,
                csProductVal.length > 0
                    ? this.state.selectAll
                        ? "All Products"
                        : csProductVal
                    : ""
            );
            this.setState({
                keyBoardEvent: false,
                keyEventName: "",
            });
        }
    };
    handleKeyDown = (event) => {
        // const newUrl = this.buildUrl(
        //   event.target.value,
        //   this.state.dropdownValue,
        //   this.state.fieldedValue,
        //   this.props.appliedFilters
        // );
        // const newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=Drugs - JNJ/Established Products`;
        let newUrl;
        let selectedFilters;
        let selectedProducts = this.getSelectedProducts();
        let selectedDocTypes = this.getSelectedDocTypes();
        let csProductVal = selectedProducts.map((data) => data).join(";");
        let csPathVal = selectedDocTypes.map((data) => data).join(";");
        if (
            this.state.searchKeyword.length > 0 &&
            selectedProducts.length <= 0 &&
            selectedDocTypes.length <= 0
        ) {
            newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=Drugs - JNJ/Established Products`;
        } else if (
            selectedProducts.length > 0 &&
            this.state.searchKeyword.length > 0 &&
            selectedDocTypes.length <= 0
        ) {
            if (this.state.selectAll) {
                selectedFilters = "Drugs - JNJ/Established Products";
            } else {
                selectedFilters = selectedProducts
                    .map((data) => `Drugs - JNJ/Established Products/${data}`)
                    .join(";");
            }
            newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=${selectedFilters}`;
        } else if (
            selectedProducts.length > 0 &&
            this.state.searchKeyword.length <= 0 &&
            selectedDocTypes.length <= 0
        ) {
            if (this.state.selectAll) {
                selectedFilters = "Drugs - JNJ/Established Products";
            } else {
                selectedFilters = selectedProducts
                    .map((data) => `Drugs - JNJ/Established Products/${data}`)
                    .join(";");
            }
            newUrl = `/results?query=&q=All Fields&filters=${selectedFilters}`;
        } else if (
            selectedProducts.length <= 0 &&
            this.state.searchKeyword.length <= 0 &&
            selectedDocTypes.length > 0
        ) {
            selectedFilters = selectedDocTypes
                .map((data) => `Document Type/${data}`)
                .join(";");
            newUrl = `/results?query=&q=All Fields&filters=Drugs - JNJ/Established Products;${selectedFilters}`;
        } else if (
            selectedProducts.length <= 0 &&
            this.state.searchKeyword.length > 0 &&
            selectedDocTypes.length > 0
        ) {
            selectedFilters = selectedDocTypes
                .map((data) => `Document Type/${data}`)
                .join(";");
            newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=Drugs - JNJ/Established Products;${selectedFilters}`;
        } else if (
            selectedProducts.length > 0 &&
            this.state.searchKeyword.length <= 0 &&
            selectedDocTypes.length > 0
        ) {
            let productFilter;
            let docTypeFilter;
            if (this.state.selectAll) {
                productFilter = "Drugs - JNJ/Established Products";
            } else {
                productFilter = selectedProducts
                    .map((data) => `Drugs - JNJ/Established Products/${data}`)
                    .join(";");
            }
            docTypeFilter = selectedDocTypes
                .map((data) => `Document Type/${data}`)
                .join(";");
            selectedFilters = productFilter.concat(";", docTypeFilter);
            newUrl = `/results?query=&q=All Fields&filters=${selectedFilters}`;
        } else {
            let productFilter;
            let docTypeFilter;
            if (this.state.selectAll) {
                productFilter = "Drugs - JNJ/Established Products";
            } else {
                productFilter = selectedProducts
                    .map((data) => `Drugs - JNJ/Established Products/${data}`)
                    .join(";");
            }
            docTypeFilter = selectedDocTypes
                .map((data) => `Document Type/${data}`)
                .join(";");
            selectedFilters = productFilter.concat(";", docTypeFilter);
            newUrl = `/results?query=${this.state.searchKeyword}&q=All Fields&filters=${selectedFilters}`;
        }
        if (["Enter"].includes(event.key)) {
            //   this.props.handleChangeInSearch(this.state.searchKeyword);
            //this.props.history.push(newUrl);
            window.open(newUrl, "_blank");
            const ts = new trackingService();
            ts.indexTrackingData(
                localStorage.getItem("userdisplayName"),
                localStorage.getItem("wwid"),
                localStorage.getItem("username"),
                localStorage.getItem("function"),
                localStorage.getItem("region"),
                localStorage.getItem("userproducts"),
                localStorage.getItem("doctypepref"),
                localStorage.getItem("sid"),
                localStorage.getItem("deviceType"),
                localStorage.getItem("deviceOS"),
                localStorage.getItem("browserName"),
                localStorage.getItem("browserVersion"),
                localStorage.getItem("jnjDepartment"),
                localStorage.getItem("companyname"),
                "Conducted Established Products Search",
                "",
                window.location.href,
                this.state.searchKeyword,
                selectedProducts.length <= 0 &&
                    this.state.searchKeyword.length <= 0 &&
                    selectedDocTypes.length > 0
                    ? `Drugs - JNJ/Established Products;${selectedFilters}`
                    : selectedFilters
                        ? selectedFilters
                        : "Drugs - JNJ/Established Products", //this.props.appliedFilters,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                `Established Products - ${csPathVal}`,
                csProductVal.length > 0
                    ? this.state.selectAll
                        ? "All Products"
                        : csProductVal
                    : ""
            );
        }
        if (["ArrowDown"].includes(event.key) || ["ArrowUp"].includes(event.key)) {
            //console.log('Arrow Action')
            this.setState({
                keyBoardEvent: true,
                keyEventName: event.key,
            });
        }
    };
    getSelectedProducts() {
        let selectedProducts = [];
        this.state.productSelectStatus.map((val, key) => {
            if (val) {
                selectedProducts.push(CSEPSelectedProduct[key]);
            }
        });
        return selectedProducts;
    }
    getSelectedDocTypes() {
        let selectedDocTypes = [];
        this.state.documentTypeSelectStatus.map((val, key) => {
            if (val) {
                selectedDocTypes.push(CSEPDocumentType[key]);
            }
        });
        return selectedDocTypes;
    }
    showDetails = () => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            "Expanded Established Products tile under content shortcuts",
            "",
            window.location.href
            //   this.state.searchKeyword,
            //   this.props.appliedFilters
        );
        let productSelectStatus = [];
        let documentTypeSelectStatus = [];
        for (let index = 0; index < CSEPSelectedProduct.length; index++) {
            productSelectStatus.push(false);
        }
        for (let index = 0; index < CSEPDocumentType.length; index++) {
            documentTypeSelectStatus.push(false);
        }
        this.setState(
            {
                showCSModal: !this.state.showCSModal,
                productSelectStatus: productSelectStatus,
                documentTypeSelectStatus: documentTypeSelectStatus,
                selectAll: false,
                selectAllDoc: false,
            },
            () => {
                this.props.handelEPCardDetail(this.state.showCSModal);
            }
        );
    };
   
    handleCloseModal = () => {
        this.setState({ showCSModal: false, searchKeyword: "" }, () => {
            this.props.handelEPCardDetail(this.state.showCSModal);
        });
    };
    
    toggleExpandSectioncns = () => {
        this.setState({
            showContentDosage: !this.state.showContentDosage,
            showContentDocumentType: false,
            showNote: false,
        })
    }

    toggleExpandSectionDocumentType = () => {
        this.setState({
            showContentDosage: false,
            showContentDocumentType: !this.state.showContentDocumentType,
            showNote: false,
        })
    }

    handleCloseModalNote = () => {
        this.setState({
            showNote: false
        })
    }

    render() {
      const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        return (
            <div className="GenAI-Recomm-ContentShortcutInnerWapper">
                {this.state.showCSModal && (
                    <>
                        <div
                            className="gen-ai-cs-modalHeader"
                            style={{
                                justifyContent: "right",
                                display: this.state.products.length <= 0 && "none",
                            }}
                        >
                            <div className="gen-ai-cs-popup-cancel-btn popoverAvoidClickOutside">
                                <span className="popoverAvoidClickOutside" onClick={this.handleCloseModal}>
                                    <svg width="18px" height="18px" className="popoverAvoidClickOutside" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier"> <title>cancel</title> <g id="Page-1" stroke-width="0.00512" fill="none" fill-rule="evenodd">
                                            <g id="work-case" fill="#afa7a7" transform="translate(91.520000, 91.520000)">
                                                <polygon id="Close" points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"> </polygon> </g> </g> </g></svg>
                                </span>
                            </div>
                        </div>
                        <div
                    className="gen-ai-ims-home-cs-modalHeader"
                    style={{
                      justifyContent: "center",
                      borderBottom: "none",
                    //   margin: " 4% 0 0 0",
                    }}
                  >
                    <div className="gen-ai-ims-home-cs-header-wrapper" style={{ height: "44px" }}>
                      <div className="cs-input-box-wrapper">
                        <input
                          name="searchBar"
                          className="gen-ai-ims-home-cs-input-search-box"
                          title="EP Search Box"
                          value={this.state.searchKeyword}
                          onChange={this.handleChangeInSearch}
                          onKeyDown={this.handleKeyDown}
                        />
                        <span className="gen-ai-ims-home-cs-icon-wrapper">
                          {this.state.searchKeyword && (
                            <img
                              src={crossIcon}
                              className="input-search-cancel-icon"
                              alt="clear"
                              title="Click here to clear the search terms"
                              onClick={this.handleCancelSearchKeyword}
                            />
                          )}
                        </span>
                      </div>
                      <span
                        className="gen-ai-ims-home-cs-search-icon-wrapper-webView"
                        onClick={this.handleOnClickSearchIcon}
                      >
                        <img
                          src={magnifyingGlass}
                          className="gen-ai-ims-home-cs-magnifyingGlass"
                          alt="search"
                          title="Search"
                        />
                      </span>
                    </div>
                  </div>
                        {this.state.showNote && <div className="gen-ai-ims-home-content-short-note-main-div">
                            <div className="gen-ai-ims-home-content-short-note-sub-main-div">
                                <div className="gen-ai-ims-home-content-short-note">
                                    PLEASE NOTE: One or more of the categories listed may retrieve zero results for the product you selected. This is because 1) content within those categories has not yet been made available for that product, or 2) the content is restricted/firewalled due to your Location and/or Function.</div>
                                <div className="gen-ai-ims-home-cs-popup-cancel-btn popoverAvoidClickOutside">
                                    <span className="popoverAvoidClickOutside" onClick={this.handleCloseModalNote}>
                                        <svg width="18px" height="18px" className="popoverAvoidClickOutside" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                            <g id="SVGRepo_iconCarrier"> <title>cancel</title> <g id="Page-1" stroke-width="0.00512" fill="none" fill-rule="evenodd">
                                                <g id="work-case" fill="#eb1700" transform="translate(91.520000, 91.520000)">
                                                    <polygon id="Close" points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"> </polygon>
                                                </g>
                                            </g>
                                            </g>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>}
                         
                        <div className="gen-ai-ims-home-contentshortcut-div">
                            <div className="gen-ai-ims-home-contentshortcut-inside-div-Admins-dosages">
                                <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
                                    <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                                        <span className="gen-ai-ims-home-contentshortcut-div-inside-span">Select Product</span>
                                        {this.state.showContentDosage ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncns} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                                            <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncns} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                                        }
                                    </div>
                                </div>
                                <div> {this.state.showContentDosage && <div className="gen-ai-ims-home-modal-body-height-genAI">
                                    <div className="cs-modalList gen-ai-cs-modalList">
                                            <div className="cs-select-preference-wrapper">
                                                <div className="cs-fieldset-wrapper">
                                                    <ul className="cs-preference-lists">
                                                        <li>
                                                            <label
                                                                key={Math.random()}
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    let a = this.state.productSelectStatus;
                                                                    a = a.map((x) => !this.state.selectAll);
                                                                    this.setState({
                                                                        productSelectStatus: a,
                                                                        selectAll: !this.state.selectAll,
                                                                    });
                                                                }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.selectAll}
                                                                    onChange={() => { }}
                                                                    className="gen-ai-CSEP-product-checkbox"
                                                                />
                                                                Select All
                                                            </label>
                                                        </li>
                                                        {CSEPSelectedProduct.length > 0 &&
                                                            CSEPSelectedProduct.map((data, index) => {
                                                                return (
                                                                    <li>
                                                                        <label
                                                                           htmlFor="myInput"
                                                                            key={data + index + Math.random()}
                                                                            onClick={(event) => {
                                                                                event.stopPropagation();
                                                                                let a = this.state.productSelectStatus;
                                                                                a[index] =
                                                                                    !this.state.productSelectStatus[index];
                                                                                this.setState({
                                                                                    selectAll: false,
                                                                                    productSelectStatus: a,
                                                                                });
                                                                                let checkSelectStatus = a.filter(
                                                                                    (item) => item
                                                                                );
                                                                                if (
                                                                                    checkSelectStatus.length ===
                                                                                    CSEPSelectedProduct.length
                                                                                ) {
                                                                                    this.setState({ selectAll: true });
                                                                                }
                                                                            }}
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={
                                                                                    this.state.productSelectStatus[index]
                                                                                }
                                                                                className="gen-ai-CSEP-product-checkbox"
                                                                                onChange={() => { }}
                                                                            />
                                                                            {data}
                                                                        </label>
                                                                    </li>
                                                                );
                                                            })}
                                                    </ul>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                                }</div>
                               
                                <div>
                                <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
                                    <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                                        <span className="gen-ai-ims-home-contentshortcut-div-inside-span">Document Type</span>
                                        {this.state.showContentDocumentType ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionDocumentType} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                                            <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionDocumentType} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                                        }
                                    </div>
                                </div>
                                    {
                                        this.state.showContentDocumentType && <div className="gen-ai-ims-home-modal-body-height-genAI">
                                            <div className="cs-modalList gen-ai-cs-modalList">
                                                <div className="cs-select-preference-wrapper">
                                                    <div className="gen-ai-ims-home-cs-fieldset-wrapper">
                                                        <ul className="cs-preference-lists">
                                                            <li>
                                                                <label
                                                                    key={Math.random()}
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        let a = this.state.documentTypeSelectStatus;
                                                                        a = a.map((x) => !this.state.selectAllDoc);
                                                                        this.setState({
                                                                            documentTypeSelectStatus: a,
                                                                            selectAllDoc: !this.state.selectAllDoc,
                                                                        });
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                         className="gen-ai-CSEP-documentType-checkbox"
                                                                        checked={this.state.selectAllDoc}
                                                                        onChange={() => { }}
                                                                    />
                                                                    Select All
                                                                </label>
                                                            </li>
                                                            {CSEPDocumentType.length > 0 &&
                                                                CSEPDocumentType.map((data, index) => {
                                                                    return (
                                                                        <li>
                                                                            <label
                                                                                key={data + index + Math.random()}
                                                                                onClick={(event) => {
                                                                                    event.stopPropagation();
                                                                                    let a =
                                                                                        this.state.documentTypeSelectStatus;
                                                                                    a[index] =
                                                                                        !this.state.documentTypeSelectStatus[
                                                                                        index
                                                                                        ];
                                                                                    this.setState({
                                                                                        selectAllDoc: false,
                                                                                        documentTypeSelectStatus: a,
                                                                                    });
                                                                                    let checkSelectStatus = a.filter(
                                                                                        (item) => item
                                                                                    );
                                                                                    if (
                                                                                        checkSelectStatus.length ===
                                                                                        CSEPDocumentType.length
                                                                                    ) {
                                                                                        this.setState({ selectAllDoc: true });
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        this.state.documentTypeSelectStatus[
                                                                                        index
                                                                                        ]
                                                                                    }
                                                                                    className="gen-ai-CSEP-documentType-checkbox"
                                                                                    onChange={() => { }}
                                                                                />
                                                                                {data}
                                                                            </label>
                                                                        </li>
                                                                    );
                                                                })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                )}
                   {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}

                   </div>
            );
    }
}

export default EstablishedProductGenAIRec;
